import { ReactNode } from "react";
import { imgLoadingScreenBackground } from "@/shared/assets/img";

type Props = {
  children: ReactNode;
};

export default function LoadingScreenWrapper({ children }: Props) {
  return (
    <div
      className="relative flex justify-center items-center size-full bg-dark-900 overflow-hidden"
      style={{
        backgroundImage: `url(${imgLoadingScreenBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="z-1 flex flex-col justify-center items-center size-full">{children}</div>
      <div className="absolute content-[''] w-[74%] h-[74%] bottom-[-94%] left-[50%] bg-[#D73434] rounded-[100%] blur-[220px] -translate-x-1/2" />
    </div>
  );
}
